<template>
  <b-collapse class="card" :open="open">
    <div v-if="header" slot="trigger" slot-scope="props" class="card-header level">
      <div class="level-left">
        <a class="level-item">
          <svgicon
            v-if="props.open"
            name="contract"
            color="whitesmoke"
            width="25"
            height="25">
          </svgicon>
          <svgicon
            v-else
            name="expand"
            color="whitesmoke"
            width="25"
            height="25">
          </svgicon>
        </a>
        <p class="level-item">{{ title }}</p>
        <slot name="left-header" class="level-item"></slot>
      </div>
      <div class="level-right">
        <slot name="right-header" class="level-item"></slot>
      </div>
    </div>
    <div class="card-content">
      <slot></slot>
    </div>
  </b-collapse>
</template>

<script>
export default {
  name: 'CollapseCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    header: {
      type: Boolean,
      default: true,
    },
    open: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

.card {
  background: $form-subitem;
}

.card-content {
  background: $sidebar-active;
  padding: .75rem;
}

.card-header {
  background: $form-subitem;
  border-bottom: 1px solid $border-color;
  padding: .75rem 1.5rem;
  color: whitesmoke;
  background: $sidebar-active;
}

.card-header-icon {
  order: -1;
  padding: 0;
}
</style>
